<template>
  <b-overlay :show="Loading">
    <div class="my-register-page" style="font-size: 14px">
      <div class="my-container">
        <b-row class="mb-3 align-items-center">
          <b-col>
            <b-link class="xn-back" @click="GoBack">
              <b-icon icon="arrow-left"></b-icon>
              {{ $t("XabarnomaBackToDetail") }}
            </b-link>
          </b-col>
        </b-row>

        <h2 class="xn-subject mb-1">{{ $t("XabarnomaReply") }}</h2>
        <div class="text-muted mb-3">{{ Detail.subject }}</div>

        <div class="cardStyleEdit p-3 mb-3">
          <b-row>
            <b-col cols="12" md="6" class="mb-3">
              <div class="xn-label">{{ $t("XabarnomaNumber") }}</div>
              <div class="xn-value">{{ Detail.docNumber || "—" }}</div>
            </b-col>
            <b-col
              cols="12"
              md="6"
              class="mb-3"
              v-if="Detail.replyDeadlineDate"
            >
              <div class="xn-label">{{ $t("XabarnomaReplyDeadline") }}</div>
              <div class="xn-value xn-value--danger">
                {{ Detail.replyDeadlineDate }}
              </div>
            </b-col>
          </b-row>

          <custom-textarea
            v-model="form.replyText"
            :rows="8"
            :label="$t('XabarnomaReplyText')"
            :placeholder="$t('XabarnomaReplyText')"
          />
          <div class="text-right xn-counter" :class="{ 'xn-counter--over': IsTextOver }">
            {{ form.replyText.length }} / {{ MaxLength }}
          </div>

          <div class="xn-uploader mt-3" @click="TriggerFile">
            <input
              ref="fileInput"
              type="file"
              class="xn-uploader__input"
              accept=".doc,.xls,.pdf,.zip"
              @change="HandleFileChange"
            />
            <div class="xn-uploader__icon">
              <b-icon icon="paperclip" font-scale="1.4"></b-icon>
            </div>
            <div>
              <div class="xn-uploader__title">{{ $t("attachFile") }}</div>
              <div class="xn-uploader__hint">{{ $t("XabarnomaFileRule") }}</div>
            </div>
            <b-spinner v-if="FileUploading" small class="ml-auto"></b-spinner>
          </div>

          <b-table-simple
            bordered
            responsive
            class="mt-3 mb-0"
            v-if="form.files.length"
          >
            <b-tbody>
              <b-tr variant="primary">
                <b-td style="width: 40px">#</b-td>
                <b-td>{{ $t("fileName") }}</b-td>
                <b-td class="text-center" style="width: 80px">
                  {{ $t("actions") }}
                </b-td>
              </b-tr>
              <b-tr
                v-for="(file, index) in form.files"
                :key="file.id"
                style="background-color: white"
              >
                <b-td>{{ index + 1 }}</b-td>
                <b-td>{{ file.fileName }}</b-td>
                <b-td class="text-center">
                  <b-link @click="RemoveFile(index)">
                    <b-icon font-scale="1.2" icon="trash"></b-icon>
                  </b-link>
                </b-td>
              </b-tr>
            </b-tbody>
          </b-table-simple>
        </div>

        <b-row class="mb-4">
          <b-col cols="6">
            <b-button variant="outline-danger" @click="GoBack">
              {{ $t("cancel") }}
            </b-button>
          </b-col>
          <b-col cols="6" class="text-right">
            <b-button
              variant="primary"
              :disabled="Saving || FileUploading || !CanSubmit"
              @click="Submit"
            >
              <b-spinner v-if="Saving" small></b-spinner>
              {{ $t("send") }}
            </b-button>
          </b-col>
        </b-row>
      </div>
    </div>
  </b-overlay>
</template>

<script>
import {
  BRow,
  BCol,
  BButton,
  BOverlay,
  BSpinner,
  BTableSimple,
  BTbody,
  BTr,
  BTd,
  BIcon,
  BLink,
} from "bootstrap-vue";
import customTextarea from "@/components/elements/customTextarea.vue";
import XabarnomaService from "@/services/xabarnoma.service";

const ALLOWED_EXTENSIONS = ["doc", "xls", "pdf", "zip"];
const MAX_FILE_SIZE = 10 * 1024 * 1024;

export default {
  components: {
    BRow,
    BCol,
    BButton,
    BOverlay,
    BSpinner,
    BTableSimple,
    BTbody,
    BTr,
    BTd,
    BIcon,
    BLink,
    customTextarea,
  },
  data() {
    return {
      Loading: false,
      Saving: false,
      FileUploading: false,
      MaxLength: 1500,
      Detail: {},
      form: {
        replyText: "",
        files: [],
      },
    };
  },
  created() {
    this.LoadDetail();
  },
  computed: {
    RecipientId() {
      return this.$route.params.id;
    },
    IsTextOver() {
      return this.form.replyText.length > this.MaxLength;
    },
    CanSubmit() {
      return !!this.form.replyText.trim() && !this.IsTextOver;
    },
  },
  methods: {
    GoBack() {
      this.$router.push({
        name: "XabarnomaView",
        params: { id: this.RecipientId },
      });
    },
    LoadDetail() {
      this.Loading = true;
      XabarnomaService.GetDetail(this.RecipientId)
        .then((res) => {
          this.Detail = res.data || {};
          this.Loading = false;
          // Javob allaqachon berilgan bo'lsa qayta yuborishga ruxsat yo'q.
          if (this.Detail.reply) {
            this.makeToast(this.$t("XabarnomaAlreadyReplied"), "warning");
            this.GoBack();
          }
        })
        .catch((error) => {
          this.Loading = false;
          this.makeToast(
            (error.response && error.response.data) || error.message,
            "error"
          );
        });
    },
    TriggerFile() {
      if (this.FileUploading) return;
      this.$refs.fileInput && this.$refs.fileInput.click();
    },
    ResetFileInput() {
      if (this.$refs.fileInput) this.$refs.fileInput.value = "";
    },
    HandleFileChange(event) {
      const file = event.target.files && event.target.files[0];
      if (!file) return;

      const parts = file.name.split(".");
      const extension = parts.length > 1 ? parts.pop().toLowerCase() : "";
      if (ALLOWED_EXTENSIONS.indexOf(extension) === -1) {
        this.ResetFileInput();
        this.makeToast(this.$t("XabarnomaFileFormatError"), "error");
        return;
      }
      if (file.size > MAX_FILE_SIZE) {
        this.ResetFileInput();
        this.makeToast(this.$t("XabarnomaFileSizeError"), "error");
        return;
      }

      this.FileUploading = true;
      XabarnomaService.UploadReplyFile(file)
        .then((res) => {
          let payload = res.data;
          if (Array.isArray(payload)) payload = payload[0];
          if (payload && payload.id) {
            this.form.files.push({
              id: payload.id,
              fileName: payload.fileName || file.name,
            });
          }
          this.FileUploading = false;
          this.ResetFileInput();
        })
        .catch((error) => {
          this.FileUploading = false;
          this.ResetFileInput();
          this.makeToast(
            (error.response && error.response.data) || error.message,
            "error"
          );
        });
    },
    RemoveFile(index) {
      const file = this.form.files[index];
      if (!file) return;
      XabarnomaService.DeleteReplyFile(file.id)
        .then(() => {
          this.form.files.splice(index, 1);
        })
        .catch(() => {
          this.form.files.splice(index, 1);
        });
    },
    Submit() {
      if (!this.CanSubmit) return;
      this.Saving = true;
      XabarnomaService.SubmitReply(
        Number(this.RecipientId),
        this.form.replyText.trim(),
        this.form.files.map((f) => f.id)
      )
        .then(() => {
          this.Saving = false;
          this.makeToast(this.$t("XabarnomaReplySuccess"), "success");
          this.GoBack();
        })
        .catch((error) => {
          this.Saving = false;
          this.makeToast(
            (error.response && error.response.data) || error.message,
            "error"
          );
        });
    },
    makeToast(message, type) {
      let a = "";
      if (message && message.status == 500) {
        a = message.title;
      } else if (message && message.status == 400 && message.errors) {
        const errors = Object.values(message.errors);
        a = errors.map((el, i) => i + 1 + "." + el).join("\n");
      } else {
        a = message;
      }
      this.$toast.open({
        message: a,
        type: type,
        duration: 5000,
        dismissible: true,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables.scss";

.xn-back {
  color: $primary-dark;
  font-weight: 600;
  cursor: pointer;
}

.xn-subject {
  font-weight: 700;
}

.xn-label {
  font-size: 12px;
  text-transform: uppercase;
  color: #6b7280;
}

.xn-value {
  font-weight: 600;

  &--danger {
    color: $danger;
  }
}

.xn-counter {
  font-size: 12px;
  color: #6b7280;

  &--over {
    color: $danger;
    font-weight: 600;
  }
}

.xn-uploader {
  display: flex;
  align-items: center;
  gap: 12px;
  border: 1.5px dashed #d1d5db;
  border-radius: 12px;
  padding: 14px 16px;
  cursor: pointer;
  transition: border-color 0.2s, background-color 0.2s;

  &:hover {
    border-color: $primary;
    background: #f7faff;
  }
}

.xn-uploader__input {
  display: none;
}

.xn-uploader__icon {
  color: $primary;
}

.xn-uploader__title {
  font-weight: 600;
}

.xn-uploader__hint {
  font-size: 12px;
  color: #6b7280;
}

.cardStyleEdit {
  padding: 5px;
  background-color: #eaf2ff;
  border-radius: 5px;
}

.styleText {
  font-weight: 900;
  font-size: 16px;
}
</style>
